import { ReactNode } from 'react'
import styled from 'styled-components'

import CheckboxIcon from '../../icons/CheckboxLight'

type Options = {
  primaryTextFontWeight?: number
  primaryTextLineHeight?: number
  primaryTextFontSize?: string
  primaryTextColor?: string
  secondaryTextFontSize?: string
  secondaryTextLineHeight?: number
  secondaryTextColor?: string
}

const Item = styled.li<Options>`
  display: flex;

  svg {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    margin-top: 4px;
    flex-shrink: 0;
  }

  div {
    p {
      margin: 0;
    }

    p:first-child {
      font-size: ${({ primaryTextFontSize }) => primaryTextFontSize || '16px'};
      color: ${({ theme, primaryTextColor }) =>
        primaryTextColor || theme['-ds-core-400'].value};
      line-height: ${({ primaryTextLineHeight }) => primaryTextLineHeight || 2};
    }
    p:last-child {
      line-height: 1.25;
      font-size: ${({ secondaryTextFontSize }) =>
        secondaryTextFontSize || '16px'};
      color: ${({ theme, secondaryTextColor }) =>
        secondaryTextColor || theme['-ds-neutral-600'].value};
      line-height: ${({ secondaryTextLineHeight }) =>
        secondaryTextLineHeight || 1.5};
    }
  }
`

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;

  li:not(:last-child) {
    margin-bottom: 30px;
  }
`

type ChecklistItem = {
  primaryText: ReactNode
  secondaryText?: ReactNode
}

type ChecklistProps = Options & {
  items: ChecklistItem[]
}

const Checklist = ({
  items,
  primaryTextFontSize,
  primaryTextFontWeight,
  primaryTextColor,
  primaryTextLineHeight,
  secondaryTextFontSize,
  secondaryTextColor,
  secondaryTextLineHeight,
}: ChecklistProps) => {
  return (
    <List>
      {items?.map(({ primaryText, secondaryText }) => (
        <Item
          key={primaryText.toString()}
          primaryTextColor={primaryTextColor}
          secondaryTextColor={secondaryTextColor}
          primaryTextFontSize={primaryTextFontSize}
          primaryTextFontWeight={primaryTextFontWeight}
          primaryTextLineHeight={primaryTextLineHeight}
          secondaryTextFontSize={secondaryTextFontSize}
          secondaryTextLineHeight={secondaryTextLineHeight}
        >
          <CheckboxIcon />
          <div>
            <p>{primaryText}</p>
            <p>{secondaryText}</p>
          </div>
        </Item>
      ))}
    </List>
  )
}

export default Checklist
